<template>
  <div style="width: 100%;height: 100%">
    <h3 style="position: absolute; top: 0; left: 50%; transform:translate(-50%,0);">
      <span>{{picText}}</span>
    </h3>
    <div>
      <img :src="groundtruth_source" :id="truePicId" alt=""/>
    </div>
    <div style="position: absolute; bottom: 0; left: 50%; transform:translate(-50%,0);">
      <span @click="resetPic(truePicId)">
        <i class="el-icon-refresh"></i>
      </span>
      <span @click="rotatePic(truePicId)">
        <i class="el-icon-refresh-right"></i>
      </span>
      <span @click="horizonPic(truePicId)">
        <i class="el-icon-right"></i>
      </span>
      <span @click="verticalPic(truePicId)">
        <i class="el-icon-top"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TruthImageCard",
  data(){
    return{
      truePicId: '',
      datasetName: [20210101, 20210701, 20210702, 20210703],
      picText: 'H&E image',
      groundtruth_source: '',
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
    }
  },
  props:{
    cardID: String,
  },
  mounted() {
    this.truePicId = 'true_pic' + this.cardID
    this.groundtruth_source = this.$attrs.data.groundtruth_source
    if (this.$attrs.data.datasetID === -1){
      this.picText = this.$attrs.data.picText
    } else if (this.datasetName.includes(this.$attrs.data.datasetID)){
      this.picText = 'Immunofluorescent imaging'
    }
    // console.log(this.$attrs)
    // console.log(this.groundtruth_source)
    // console.log(this.picText)
  },
  methods: {
    resetPic(elename) {
      this.rotateX = 0
      this.rotateY = 0
      this.rotateZ = 0
      var box = document.getElementById(elename);
      box.style.transform = 'rotateX(' + 0 + 'deg)';
      box.style.transform = 'rotateY(' + 0 + 'deg)';
      box.style.transform = 'rotateZ(' + 0 + 'deg)';
    },
    rotatePic(elename) {
      this.rotateZ = this.rotateZ + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateZ(' + 90 * this.rotateZ + 'deg)';
    },
    horizonPic(elename) {
      this.rotateY = this.rotateY + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateY(' + 180 * this.rotateY + 'deg)';
    },
    verticalPic(elename) {
      this.rotateX = this.rotateX + 1
      var box = document.getElementById(elename);
      box.style.transform = 'rotateX(' + 180 * this.rotateX + 'deg)';
    },
  }
}
</script>

<style scoped>
img{
  width: 90%;
  height: 90%;
  object-fit: cover;
}

</style>
